import { connect } from 'react-redux'
import { selectIsLoadingTicketActions } from 'selectors/app'
import {
  selectCurrentTicket,
  selectIsTwitterDM,
  selectTicketCustomer,
} from 'selectors/tickets'
import { selectTwitterRecipients } from 'ducks/drafts'

import Twitter from './view'

const select = state => ({
  recipients: selectTwitterRecipients(state),
  customer: selectTicketCustomer(state),
  isDM: selectIsTwitterDM(state),
  ticket: selectCurrentTicket(state),
  isLoadingActions: selectIsLoadingTicketActions(state),
})

export default connect(select, null)(Twitter)
